import { NEUTRAL, ORANGE, VIOLET } from "../../styles/brandTokens";

/** Auto Resolver state words, shared by the ticket header and the Auto Agent Monitor queue. */
export const RESOLVER_STATE_LABELS: Record<string, string> = {
  running: "Running",
  waiting: "Waiting",
  success: "Completed",
  cancelled: "Cancelled",
  declined: "Not attempted",
};

/**
 * Resolver state as a dot and a word, no container. The dot carries the color; the text stays
 * secondary except for "waiting", the one state that asks a person to act (orange = attention).
 * Green and red have no brand token, so they are muted to sit beside the plum.
 */
export const RESOLVER_STATE_COLORS: Record<string, { dot: string; text: string }> = {
  running: { dot: VIOLET.main, text: NEUTRAL.textSecondary },
  waiting: { dot: ORANGE.main, text: ORANGE.text },
  success: { dot: "#6BAA76", text: NEUTRAL.textSecondary },
  cancelled: { dot: NEUTRAL.borderStrong, text: NEUTRAL.textMuted },
  declined: { dot: NEUTRAL.borderStrong, text: NEUTRAL.textSecondary },
};

export const STATE_DOT_SIZE = 7;
